import { gql } from '@apollo/client';

export const keywordsQuery = gql`
  query Keywords {
    keywords(filter: { path: "/" }) {
      id
      term
      url
    }
  }
`;

const temp = 'just for eslint';

export default temp;
